<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12 col-md-6">
    <app-checkbox-form-field
      formControlName="caseContained"
      [label]="'case.fields.caseContained.label' | translate"
      [helpText]="'case.fields.caseContained.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-datepicker-form-field
      formControlName="caseContainedDate"
      [label]="'case.fields.caseContainedDate.label' | translate"
      [helpText]="'case.fields.caseContainedDate.help'"
      [viewMode]="viewMode"
    ></app-datepicker-form-field>
  </div>
  <div class="col-12 col-md-12">
    <app-rich-text-editor
      formControlName="containmentSummary"
      [label]="'case.fields.containmentSummary.label' | translate"
      [helpText]="'case.fields.containmentSummary.help'"
      [readonly]="viewMode"
      [isRequired]="form.get('caseContained')?.value"
      [editableInline]="!form.disabled"
    >
    </app-rich-text-editor>
  </div>
  <div class="col-12 col-md-12">
    <app-rich-text-editor
      formControlName="problemResolutionSummary"
      [label]="'case.fields.problemResolutionSummary.label' | translate"
      [helpText]="'case.fields.problemResolutionSummary.help'"
      [readonly]="viewMode"
      [isRequired]="isProblemResolutionSummaryReqired"
      [editableInline]="!form.disabled"
    ></app-rich-text-editor>
  </div>
      <div class="col-12 col-md-6">
      <app-input-form-field
        formControlName="causeCode"
        [label]="'case.fields.causeCode.label' | translate"
        [helpText]="'case.fields.causeCode.help'"
        [translatable]="false"
        [viewMode]="viewMode"
      ></app-input-form-field>
    </div>
    <div class="col-12 col-md-6">
      <app-input-form-field
        formControlName="correctiveActionOutput"
        [label]="'case.fields.correctiveActionOutput.label' | translate"
        [helpText]="'case.fields.correctiveActionOutput.help'"
        [viewMode]="viewMode"
      ></app-input-form-field>
    </div>
    <div class="col-12 col-md-6">
      <app-configuration-select-form-field
        formControlName="rootCauseSystemComponent"
        [label]="'case.fields.rootCauseSystemComponent.label' | translate"
        [helpText]="'case.fields.rootCauseSystemComponent.help'"
        [placeholder]="'placeholders.please_select'"
        [clearable]="true"
        [searchable]="true"
        [callApiOnOpen]="true"
        [viewMode]="viewMode"
        [externalSearch]="true"
        [isRequired]="isRootCauseFieldsRequired"
        [params]="{
          type: dropdownRootCauseType,
          entry1: productCompany || '',
          entry2: productSuite || '',
          entry3: form.get('rootCauseSystemComponent')?.value || ''
        }"
        [entry]="'entry3'"
        (onSelectEvent)="clearFormField('rootCauseCategory')"
        (onClearEvent)="clearFormField('rootCauseCategory')"
      ></app-configuration-select-form-field>
    </div>
    <div class="col-12 col-md-6">
      <app-configuration-select-form-field
        formControlName="rootCauseCategory"
        [label]="'case.fields.rootCauseCategory.label' | translate"
        [helpText]="'case.fields.rootCauseCategory.help'"
        [placeholder]="'placeholders.please_select'"
        [clearable]="true"
        [searchable]="true"
        [viewMode]="viewMode"
        [callApiOnOpen]="true"
        [externalSearch]="true"
        [isRequired]="isRootCauseFieldsRequired"
        [params]="{
          type: dropdownRootCauseType,
          entry1: productCompany || '',
          entry2: productSuite || '',
          entry3: form.get('rootCauseSystemComponent')?.value || '',
          entry4: form.get('rootCauseCategory')?.value || '',
        }"
        [entry]="'entry4'"
      ></app-configuration-select-form-field>
    </div>
    <div class="col-12 col-md-6">
      <app-checkbox-form-field
        formControlName="trainingOpportunity"
        [label]="'case.fields.trainingOpportunity.label' | translate"
        [helpText]="'case.fields.trainingOpportunity.help'"
        [viewMode]="viewMode"
      ></app-checkbox-form-field>
    </div>
    <div class="col-12 col-md-6">
      <app-input-form-field
        formControlName="trainingComments"
        [label]="'case.fields.trainingComments.label' | translate"
        [helpText]="'case.fields.trainingComments.help'"
        [viewMode]="viewMode"
      ></app-input-form-field>
    </div>
    <div class="col-12 col-md-6" *ngIf="viewMode && showVerifiedKnowledge">
      <app-checkbox-form-field
        formControlName="verifiedKnowledge"
        [label]="'case.fields.verifiedKnowledge.label' | translate"
        [viewMode]="viewMode"
      ></app-checkbox-form-field>
    </div>
</div>
